// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "quill" + "." + "c0b1e89d44faeb8c" + ".js";
};